var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.triggerCloseModal()
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.triggerCloseModal()
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-container modal-trocar-responsavel-lote" },
              [
                _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Vincular Responsável em Lote")
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { id: "btn", type: "text", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.triggerCloseModal()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons icon" }, [
                          _vm._v("close")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    [
                      _c("el-row", { staticClass: "row" }, [
                        _c("p", [
                          _vm._v(
                            "Processos selecionados: " +
                              _vm._s(_vm.idsProcessos.length)
                          )
                        ])
                      ]),
                      _c("el-row", { staticClass: "row" }, [
                        _c("p", [
                          _vm._v(
                            "Selecione abaixo o nome do responsável a ser vinculado nos processos:"
                          )
                        ])
                      ]),
                      _c(
                        "el-row",
                        { staticClass: "row" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "full-width",
                              attrs: {
                                placeholder: "Selecione o responsável",
                                "no-match-text": "Usuário não encontrado",
                                "no-data-text": "Nenhum usuário disponível",
                                filterable: "filterable",
                                clearable: "clearable",
                                id: "id-selecionar-responsavel-lote"
                              },
                              model: {
                                value: _vm.usuarioVinculado,
                                callback: function($$v) {
                                  _vm.usuarioVinculado = $$v
                                },
                                expression: "usuarioVinculado"
                              }
                            },
                            _vm._l(_vm.usuariosDisponiveis, function(usuario) {
                              return _c("el-option", {
                                key: usuario.id,
                                staticClass: "listResponsavel",
                                attrs: {
                                  label: usuario.nomeCargo,
                                  value: usuario.id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footer", [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              !_vm.usuarioVinculado ||
                              _vm.usuariosDisponiveis.length === 0
                          },
                          on: { click: _vm.trocar }
                        },
                        [_vm._v("Confirmar")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae48d240", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae48d240","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/ModalTrocarResponsavelLote.vue
// module id = null
// module chunks = 